<bic-popup (close)="closeClicked()" [title]="confirmCancel ? 'Upload abbrechen?' : 'Dateien werden hochgeladen'"
           customClass="w-[560px]">
  <div bicPopupContent class="flex flex-col gap-4">
    @if (confirmCancel) {
      <span class="text-sm text-gray">
        Der Upload ist noch nicht abgeschlossen. Wenn Sie jetzt abbrechen, gehen die noch nicht
        hochgeladenen Dateien verloren.
      </span>
    } @else {
      @if (folderCount > 0) {
        <!-- Schritt 1: die Ordnerstruktur legt das Backend in einem Rutsch an, deshalb kein Prozentwert,
             aber derselbe Zeilenaufbau wie bei den Dateien. -->
        <div class="flex flex-col gap-2 p-3 bg-white border border-gray-200 rounded-lg shadow-sm">
          <div class="flex items-center justify-between">
            <span class="text-xs font-medium text-gray-500">
              {{ foldersPending ? 0 : folderCount }}/{{ folderCount }} Ordner angelegt
            </span>
            @if (foldersPending && waitingSeconds > 0) {
              <span class="text-xs text-gray-400">{{ waitingSeconds }} s</span>
            }
          </div>
          <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
            @if (foldersPending) {
              <div class="bg-green-500 h-1.5 w-1/3 rounded-full animate-pulse"></div>
            } @else {
              <div class="bg-green-500 h-1.5 w-full rounded-full"></div>
            }
          </div>
          <div class="flex items-center gap-2 text-xs">
            <fa-icon [icon]="faFolder" class="text-gray-400 w-3"></fa-icon>
            <span class="truncate flex-1 text-gray-600">Ordnerstruktur</span>
            @if (foldersPending) {
              <span class="text-gray-400 flex-shrink-0">läuft …</span>
            } @else {
              <fa-icon [icon]="faCircleCheck" class="text-green-500"></fa-icon>
            }
          </div>
        </div>
      }

      @if (foldersPending) {
        <!-- Formgleicher Platzhalter fuer den Datei-Block, der erst ab dem ersten Upload-Job
             erscheint (bic-file-upload-progress rendert bei 0 Jobs nichts). Ohne ihn zeigte der
             Dialog waehrend des Ordner-Anlegens nur Prosa und sprang danach auf eine ganz andere,
             viel hoehere Ansicht - das wirkte, als haette sich das Fenster gewechselt. Aufbau und
             Klassen absichtlich identisch zum Library-Block. -->
        <div class="flex flex-col gap-2 p-3 bg-white border border-gray-200 rounded-lg shadow-sm">
          <div class="flex items-center justify-between">
            <span class="text-xs font-medium text-gray-500">0/{{ totalCount }} hochgeladen</span>
            <span class="text-xs text-gray-400">0%</span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-1.5">
            <div class="bg-green-500 h-1.5 rounded-full" [style.width.%]="0"></div>
          </div>
          <span class="text-xs text-gray-400">
            {{ folderCount > 0 ? 'Wartet auf die Ordnerstruktur …' : 'Upload wird vorbereitet …' }}
          </span>
        </div>

        @if (waitingSeconds >= 10) {
          <span class="text-sm text-gray">
            Der Server braucht dafür gerade ungewöhnlich lange. Sie können hier auch abbrechen.
          </span>
        }
      } @else {
        <!-- Bei vielen Dateien darf das Popup nicht über den Viewport hinauswachsen. -->
        <div class="max-h-[45vh] overflow-y-auto">
          <bic-file-upload-progress [jobs]="jobs"></bic-file-upload-progress>
        </div>
      }
      @if (notEnqueuedCount > 0) {
        <!-- Dateien, fuer die gar kein Upload-Job entstanden ist (z.B. kein Ordner-Mapping vom
             Backend). Vorher wartete der Dialog stumm auf sie und wurde nie fertig. -->
        <span class="text-sm text-red-500">
          {{ notEnqueuedCount }} Datei{{ notEnqueuedCount !== 1 ? 'en' : '' }}
          konnte{{ notEnqueuedCount !== 1 ? 'n' : '' }} nicht eingereiht werden.
        </span>
      }
      @if (failedCount > 0) {
        <span class="text-sm text-red-500">
          {{ failedCount }} Datei{{ failedCount !== 1 ? 'en' : '' }} konnte{{ failedCount !== 1 ? 'n' : '' }} nicht hochgeladen werden.
        </span>
      }
      @if (!finished) {
        <span class="text-sm text-gray">
          Sie können dieses Fenster schließen und weiterarbeiten – der Upload läuft weiter, den
          Fortschritt zeigt die Anzeige am rechten Rand. Ein Neuladen der Seite bricht allerdings ab,
          was noch nicht hochgeladen ist.
        </span>
      }
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    @if (confirmCancel) {
      <bic-button (onClick)="keepUploading()" buttonType="white">Weiter hochladen</bic-button>
      <bic-button (onClick)="confirmCancelClicked()">Abbrechen und verwerfen</bic-button>
    } @else {
      @if (!finished) {
        <bic-button (onClick)="runInBackground()" buttonType="white">
          Im Hintergrund weiterlaufen lassen
        </bic-button>
      }
      <bic-button (onClick)="continueClicked()" [disabled]="!finished">Weiter</bic-button>
    }
  </div>
</bic-popup>
